import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AppState {
  linearProgressValue: number;
  scrollTargetId: string | null;
}

const initialState: AppState = {
  linearProgressValue: 0,
  scrollTargetId: null,
};

const animationsSlice = createSlice({
  name: 'animations',
  initialState,
  reducers: {
    incrementLinearProgress: (state: AppState) => {
      if (state.linearProgressValue >= 90) {
        return;
      }
      state.linearProgressValue += 10;
    },
    setLinearProgressValue: (state: AppState, action: PayloadAction<number>) => {
      state.linearProgressValue = action.payload;
    },
    setScrollTarget: (state: AppState, action: PayloadAction<string | null>) => {
      state.scrollTargetId = action.payload;
    },
  },
});

export const { incrementLinearProgress, setLinearProgressValue, setScrollTarget } =
  animationsSlice.actions;
export default animationsSlice.reducer;
